export const replaceAccentuation = (str: string) => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove acentos
    .replace(/([^\w]+|\s+)/g, '') // Remove espaço e outros caracteres
    .toLowerCase();
};

export const replaceAllSpecialChars = (str: string) => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove acentos
    .replace(/([^\w]+|\s+)/g, '') // Remove espaço e outros caracteres
    .replace(/-+/g, '') // Remove multiplos hífens
    .replace(/(^-+|-+$)/, '') // Remove hífens extras do final ou do inicio da string
    .toLowerCase();
};

export const sliceLabel = (label: string, maxLengthArg?: number): string => {
  const maxLength = maxLengthArg ?? 60;
  if (label?.length > maxLength) {
    return `${label.slice(0, maxLength)}...`;
  }
  return label;
};

const singularizeWord = (word: string): string => {
  return word
    .replace(/[õo]es$/, 'ão')
    .replace(/[ãa]es$/, 'ão')
    .replace(/ais$/, 'al')
    .replace(/[ée]is$/, 'el')
    .replace(/[oó]is$/, 'ol')
    .replace(/is$/, 'il')
    .replace(/ns$/, 'm')
    .replace(/([aeiou])s$/, '$1');
};

export const singularize = (text: string): string => {
  if (!text) return text;
  const words = text.split(' ');
  return words.map(singularizeWord).join(' ');
};
